export default "__VITE_ASSET__662c21bb__"